/* eslint-disable react/button-has-type */
import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {PulseLoader} from 'halogenium';
import PropTypes from 'prop-types';
import color from 'color';
import Icon from '../../Icon';
import ThemeContext from '../../ThemeContext';

export const SaveButton = (props) => {
  const {saving: loading, ...buttonProps} = props;
  const {
    text,
    icon,
    iconSize,
    type,
    theme,
    size,
    handler,
    iconColor,
    className,
    tabIndex,
    disabled,
  } = buttonProps;
  const classes = classNames(
    'button',
    'button-loader',
    {
      [className]: Boolean(className),
      [`button_${theme}`]: Boolean(theme),
      [`button_size_${size}`]: Boolean(size),
      'button-loader_loading': loading,
    }
  );
  const sizeDictionary = {
    xxxs: 6,
    xxs: 8,
    xs: 10,
    l: 12,
    xl: 16,
  };
  const loaderSize = sizeDictionary[size] || 12;

  const clickHandler = (e, fn) => {
    if (loading) {
      e.preventDefault();
      return false;
    }
    if (!fn) {
      return false;
    }
    e.preventDefault();
    return fn();
  };

  function renderBody() {
    return (
      <span>
        {icon && (
          <Icon
            glyph={icon}
            color={iconColor}
            size={iconSize}
          />
        )}
        <span className="button__text">{text}</span>
        {loading && <PulseLoader size={loaderSize} className="button-loader__indicator"/>}
      </span>
    );
  }

  return (
    <ThemeContext.Consumer>
      {(template) => {
        const bgColor = template[`${theme}Color`];
        const styles = {
          backgroundColor: bgColor,
          ':focus': {
            boxShadow: `0 0 3px 3px ${color(bgColor).lighten(0.5).hexString()}`,
          },
          ':hover': {
            backgroundColor: bgColor && color(bgColor).darken(0.1).hexString(),
          },
        };

        return (
          <button
            style={styles}
            tabIndex={tabIndex}
            type={type}
            disabled={disabled}
            className={classes}
            onClick={e => clickHandler(e, handler)}
          >
            {renderBody()}
          </button>
        );
      }}
    </ThemeContext.Consumer>
  );
};

SaveButton.propTypes = {
  saving: PropTypes.bool,
  text: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  type: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  handler: PropTypes.func,
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
};

SaveButton.defaultProps = {
  saving: false,
  text: '',
  theme: 'primary',
  size: '',
  icon: '',
  iconSize: '',
  iconColor: '',
  className: '',
  type: 'button',
  handler: null,
  tabIndex: 0,
  disabled: false,
};

const mapStateToProps = (state, ownProps) => (
  {saving: state.isSaving, ...ownProps}
);
export {showSavingOnButton, hideSavingOnButton, savingButtonReducer} from './redux';
export default connect(mapStateToProps)(SaveButton);
